import React from 'react';
import {FastField, ErrorMessage} from 'formik';
import {FormattedMessage} from 'react-intl';
import Error from '../Error';

const FormGroupCheckbox = ({id, name, label, ...rest}) => (
    <FastField name={name}>
        {({field}) => (
            <div className="custom-control custom-checkbox">
                <input type="checkbox" name={field.name} id={id} className="custom-control-input"
                    checked={field.value} onChange={field.onChange} {...rest} />
                <label className="custom-control-label" htmlFor={id}>
                    <FormattedMessage {...label} />
                </label>
                <ErrorMessage name={name}>{(message) => <Error reason={message.key} reasonParams={message.params} />}</ErrorMessage>
            </div>
        )}
    </FastField>
);

export default FormGroupCheckbox;
